// Small formatters shared by the Fix List steps.

export function formatCurrencyRound(value: number | null | undefined): string {
  if (value == null) return '—';
  return `$${Math.round(Number(value)).toLocaleString('en-US')}`;
}

/**
 * AI cost range for a finding. Uses low/high if both present; falls back to
 * a single estimate; renders an em-dash when nothing is available so the
 * column doesn't collapse.
 */
export function formatCostRange(
  low: number | null | undefined,
  high: number | null | undefined,
  fallback?: number | null,
): string {
  const l = low != null ? Math.round(Number(low)) : null;
  const h = high != null ? Math.round(Number(high)) : null;
  if (l != null && h != null) {
    return `$${l.toLocaleString('en-US')}–$${h.toLocaleString('en-US')}`;
  }
  if (l != null) return `$${l.toLocaleString('en-US')}`;
  if (h != null) return `$${h.toLocaleString('en-US')}`;
  if (fallback != null) return formatCurrencyRound(fallback);
  return '—';
}

export function midRangeFromEstimate(
  low: number | null | undefined,
  high: number | null | undefined,
  fallback?: number | null,
): number | undefined {
  if (low != null && high != null) return Math.round((Number(low) + Number(high)) / 2);
  if (low != null) return Math.round(Number(low));
  if (high != null) return Math.round(Number(high));
  if (fallback != null) return Math.round(Number(fallback));
  return undefined;
}
